import { Injectable, inject } from "@angular/core";
import { AlertService } from "@ui";
import { skip } from "rxjs/operators";
import { DefaultGridDataProvider } from "../data-grid/default-grid-data.provider";
import { DefaultGridDataService } from "../data-grid/default-grid-data.service";
import { TRANSFORMER_STATE } from "./abstract-transformer.service";
import { TransformerService } from "./transformer.service";

@Injectable({ providedIn: "root" })
export class TransformerGridDataService extends DefaultGridDataService {
  protected override defaultProvider: DefaultGridDataProvider;
  protected override alertService: AlertService;
  protected xformService = inject(TransformerService);

  public ignoreLoads = false; // override requests to load data and do nothing?

  constructor() {
    const defaultProvider = inject(DefaultGridDataProvider);
    const alertService = inject(AlertService);

    super(defaultProvider, alertService);
    this.defaultProvider = defaultProvider;
    this.alertService = alertService;
    const xformService = this.xformService;

    xformService.activeTransformer$.subscribe((xformer) => {
      this.setDataProvider(xformer?.gridDataProvider ?? null);
      if (xformer) {
        this.subscriptions.push(
          xformer.service.state$.pipe(skip(1)).subscribe((s) => {
            const esIndex = xformer.transform
              ? s === TRANSFORMER_STATE.DONE
                ? xformer.transform.afterEsIndex
                : xformer.transform.beforeEsIndex
              : (this._corpus?.esIndex ?? null);
            const reload = this._esIndex !== esIndex || s !== TRANSFORMER_STATE.PENDING;
            this._esIndex = esIndex;
            if (reload) {
              this.reload();
            }
          }),
        );
      }
    });
  }

  override loadPage(pageNumber: number) {
    if (!this.ignoreLoads) {
      super.loadPage(pageNumber);
    }
  }

  override loadColumnTypes() {
    if (!this.ignoreLoads) {
      super.loadColumnTypes();
    }
  }
}
